<template>
  <div v-permission="'live_guarantee__delete'" style="display: inline">
    <!--    single-->
    <el-button v-if="single" size="small" round @click="handleShow" style="background: #e03f3d">
      删除
    </el-button>
    <el-button v-else icon="el-icon-delete-solid" type="primary" @click="handleShow" size="mini"
               style="background: #e03f3d">
      批量删除
    </el-button>
    <el-dialog title="删除" :visible.sync="show" width="500px" center custom-class="default-table"
               :close-on-press-escape="false" :close-on-click-modal="false">
      <div style="text-align: center;">
        <h3 style="line-height: 40px;">
          确认删除已选中的【<b style="color: darkred;">{{ form.ids.length }}</b>】条数据吗？
        </h3>
        <p v-if="form.confirm_ids.length" style="line-height: 40px;">
          其中包含 <b style="color: darkred;">{{ form.confirm_ids.length }}</b> 条
          <b style="color: darkred;">已确认</b>
          的数据，删除后将<b style="color: darkred;">重新计算相关保量汇总数据</b>
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <button-submit button-txt="确 认" type="primary" @click.native.prevent="handleSure"/>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {liveGuaranteeDelete} from "../../../../api/liveGuarantee";
import {StatusConfirm} from "../index";

const ModelForm = {
  ids: [],
  confirm_ids: [],
}
export default {
  name: 'LiveGuaranteeDelete',
  props: {
    getSelection: {
      type: Function,
      required: true
    },
    single: Boolean
  },
  data() {
    return {
      show: false,
      form: {...{}, ...ModelForm}
    }
  },
  methods: {
    handleShow: function () {
      this.form = {...{}, ...ModelForm}
      const selection = this.getSelection()
      if (!selection.length) {
        this.$message.warning('请先选择行数据')
        return
      }
      const ids = []
      const confirm_ids = []
      selection.map(_ => {
        ids.push(_.id)
        if (parseInt(_.status) === StatusConfirm) {
          // 已确认的数据
          confirm_ids.push(_.id)
        }
      })
      this.form.ids = ids
      this.form.confirm_ids = confirm_ids
      this.show = true
    },
    handleSure: async function () {
      const {success} = await liveGuaranteeDelete(this.form)
      if (success) {
        this.show = false
        this.$message.success('操作成功！')
        this.$emit('success')
      }
    }
  }
}
</script>

<style scoped>

</style>
